import styled from "@emotion/styled";
import { CloseButton } from "src/atoms/CloseButton";

const CloseWarningButton = styled(CloseButton)`
  height: 20px;
  width: 20px;
`;

export { CloseWarningButton };
